__turbopack_context__.v({
  "playlist": "playlists-module-scss-module__lM2KiW__playlist",
  "playlistImage": "playlists-module-scss-module__lM2KiW__playlistImage",
  "playlistTitle": "playlists-module-scss-module__lM2KiW__playlistTitle",
  "playlists": "playlists-module-scss-module__lM2KiW__playlists",
});
